import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Chip, FormFlex } from '../../legacy/components';
import { styled } from '../../legacy/utils';
export const DocumentFilenameChip = memo(({ files }) => {
    return (_jsx(FormFlex, { rowGap: 1, columnGap: 2, children: files?.map((file, i) => (_jsx(ChipStyled, { label: file.fileName, textColor: "primary", active: true, flat: true, onClick: () => {
                if (file.openInNewTabLink) {
                    openInNewTab(file.openInNewTabLink);
                }
                else {
                    file.onClick?.();
                }
            }, clickable: true }, i))) }));
});
DocumentFilenameChip.displayName = 'DocumentFilenameChip';
// TODO: move this to client lib and use the same function in useDownloadLink then
const openInNewTab = (href) => {
    const downloadLinkAttributes = {
        href,
        target: '_blank',
    };
    const node = document.createElement('a');
    Object.keys(downloadLinkAttributes).forEach((key) => {
        const attribute = document.createAttribute(key);
        attribute.value = downloadLinkAttributes[key];
        node.setAttributeNode(attribute);
    });
    node.click();
    node.remove();
};
const ChipStyled = styled(Chip)({
    maxWidth: '240px',
});
